import { Injectable } from '@angular/core';
import { PeriodicReviewConstants } from 'src/app/periodic-review/constants/periodic-review-menu.constants';
import { FileManagementConstants } from '../constants/file-management-menu.constants';
import { PanelTypesConstants } from '../constants/panel-side-menu.constants';
import { AdminConstants } from '../constants/user-constants/admin.constants';
import { USER_ROLE } from '../constants/user-role.enum';
import { VIEW_TYPE } from '../constants/view-type.enum';
import { RequestResponse } from '../models/request-response.model';
import {
    BaseTableColumns,
    CompletedMeRequestTableColumns,
    InProgressRequestTableColumns,
    SecurityCordinatorRequestTableColumns,
    TechnicalOperationsRequestsTableColumns
} from '../models/table-columns/admin-table-columns.model';
import { LoggedInUserService } from './logged-in-user.service';

@Injectable({
    providedIn: 'root'
})
export class AdminService {
    newRequestsView = VIEW_TYPE.NEW_REQUESTS;
    returnedRequestsView = VIEW_TYPE.RETURNED_REQUESTS;
    requestsAssignedToMeView = VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS;
    requestsInProgressView = VIEW_TYPE.INPROGRESS_REQUESTS;
    completedRequestsView = VIEW_TYPE.COMPLETED_REQUESTS;
    securityCordinatorRequestsView = VIEW_TYPE.SECURITY_COORDINATOR_REQUESTS;
    technicalOperationsRequestsView = VIEW_TYPE.TECHNICAL_OPERATIONS_REQUESTS;
    completedHistoryRequests = VIEW_TYPE.COMPLETED_HISTORY_REQUESTS;

    constructor(public loggedInUserService: LoggedInUserService) {}

    convertResponseToTableData(viewType: string, response: RequestResponse) {
        if (viewType === this.newRequestsView || viewType === this.returnedRequestsView || viewType === this.requestsAssignedToMeView) {
            return new BaseTableColumns(
                response.id,
                response.requesterData.name,
                response.service.name,
                response.requesterData.client ? response.requesterData.client.name : 'N/A',
                response.createdAt
            );
        } else if (viewType === this.requestsInProgressView) {
            return new InProgressRequestTableColumns(
                response.id,
                response.requesterData.name,
                response.service.name,
                response.requesterData.client ? response.requesterData.client.name : 'N/A',
                response.createdAt,
                response.pendingWithData
            );
        } else if (viewType === this.completedRequestsView || viewType === this.completedHistoryRequests) {
            return new CompletedMeRequestTableColumns(
                response.id,
                response.requesterData.name,
                response.service.name,
                response.requesterData.client ? response.requesterData.client.name : 'N/A',
                response.createdAt,
                response.pendingWithData,
                response.icClosedAt ? response.icClosedAt : response.opsClosedAt
            );
        } else if (viewType === this.securityCordinatorRequestsView) {
            return new SecurityCordinatorRequestTableColumns(
                response.id,
                response.createdAt,
                response.creator ? response.creator.name : 'N/A',
                response.requestType,
                response.requester ? response.requester?.name : 'N/A',
                response.requester?.client ? response.requester?.client.name : 'N/A',
                response.requestStatus
            );
        } else if (viewType === this.technicalOperationsRequestsView) {
            return new TechnicalOperationsRequestsTableColumns(
                response.id,
                response.createdAt,
                response.requesterData.name ? response.requesterData.name : 'N/A',
                response.service.name,
                response.requesterData.client ? response.requesterData.client.name : 'N/A',
                response.status.toString(),
                response.opsClosedAt ? response.opsClosedAt : 'N/A'
            );
        } else {
            return undefined;
        }
    }

    getTableColumns(requestObjectName: string) {
        return AdminConstants[requestObjectName].tableColumn;
    }

    getTableHeaders(requestObjectName: string) {
        const displayColumns = AdminConstants[requestObjectName].tableColumn.map(c => c.columnDef);

        const tableWithSelection = AdminConstants[requestObjectName].tableWithSelection;
        if (tableWithSelection) {
            displayColumns.unshift('select');
        }

        return displayColumns;
    }

    isTableWithSelection(requestObjectName: string) {
        return AdminConstants[requestObjectName].tableWithSelection;
    }

    getSideMenu(userRole: USER_ROLE) {
        let list = [
            AdminConstants.NEW_REQUESTS,
            AdminConstants.RETURNED_REQUESTS,
            AdminConstants.ASSIGNED_TO_ME_REQUESTS,
            AdminConstants.INPROGRESS_REQUESTS,
            AdminConstants.COMPLETED_REQUESTS,
            AdminConstants.TECHNICAL_OPERATIONS_REQUESTS,
            AdminConstants.CALL_RECORD,
            AdminConstants.DASHBOARD,
            AdminConstants.CALL_RECORD_DASHBOARD
        ];
        //list = userRole === USER_ROLE.SHIFT_MANAGER ? this.removeDashboard(list) : list; //adding dashoard for shift manager
        list = list;
        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });
        return sideMenuList;
    }
    getSideMenuForGeneralManager(userRole: USER_ROLE) {
        let list = [
            AdminConstants.NEW_REQUESTS,
            AdminConstants.RETURNED_REQUESTS,
            AdminConstants.ASSIGNED_TO_ME_REQUESTS,
            AdminConstants.INPROGRESS_REQUESTS,
            AdminConstants.COMPLETED_REQUESTS,
            AdminConstants.TECHNICAL_OPERATIONS_REQUESTS,
            AdminConstants.SECURITY_COORDINATOR_REQUESTS,
            AdminConstants.CALL_RECORD,
            AdminConstants.DASHBOARD,
            AdminConstants.CALL_RECORD_DASHBOARD
        ];

        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });
        return sideMenuList;
    }
    getPanelSideMenu() {
        let list = [
            PanelTypesConstants.ADMINS,
            PanelTypesConstants.EMPLOYEES,
            PanelTypesConstants.CLIENTS,
            PanelTypesConstants.SERVICES,
            PanelTypesConstants.SYSTEMS,
            PanelTypesConstants.OPERATIONEMPLOYEE,
            PanelTypesConstants.TICKETING,
            PanelTypesConstants.TICKETING_MAIN_TYPES,
            PanelTypesConstants.TICKETING_SUB_TYPES,
            PanelTypesConstants.NEW_CLIENT_MANAGEMENT,
            PanelTypesConstants.GENERAL_SETTINGS,
            PanelTypesConstants.GENERAL_SETTINGS_EMPLOYEE
        ];

        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }

    getFileManagementMenu() {
        let list = [
            FileManagementConstants.STORAGE_UNIT,
            FileManagementConstants.ACTIVITY,
            FileManagementConstants.SHARED_FILES,
            FileManagementConstants.FAVORITE_LIST,
            FileManagementConstants.DELETED_FILES
        ];

        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }
    getPeriodicReviewMenu() {
        let list;
        if (this.loggedInUserService.canAccessReports() || this.loggedInUserService.isInternalUsercanAccessReports()) {
            list = [PeriodicReviewConstants.REPORTS, PeriodicReviewConstants.SHARED_REPORTS];
        } else {
            list = [PeriodicReviewConstants.SHARED_REPORTS];
        }
        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }
    getDelegationRequestMenu() {
        return [];
    }

    removeDashboard(list) {
        // const listWithoutDashboard = list;
        // const index = listWithoutDashboard.findIndex(i => i.viewType === VIEW_TYPE.DASHBOARD || i.viewType === VIEW_TYPE.CALL_RECORD_DASHBOARD);
        // listWithoutDashboard.splice(index, 1);
        // return listWithoutDashboard;
        return list.filter(item => item.viewType !== VIEW_TYPE.DASHBOARD && item.viewType !== VIEW_TYPE.CALL_RECORD_DASHBOARD);
    }
}
